import fallbackImg from '../../assets/user.png'; // Import the fallback image
import { formatDistanceToNow } from 'date-fns';

// Function to format Firestore timestamp to "time ago" format
export const formatDate = (timestamp) => {
  const date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date object
  return formatDistanceToNow(date, { addSuffix: true }); // Format date to "time ago" format
};


export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  {
    field: "user",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.photoUrl || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            alt="avatar"
            onError={(e) => e.target.src = fallbackImg} // Fallback on error
          />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "Name",
    width: 200,
    renderCell: (params) => {
      return (
        <span>{params.row.name || 'Guest'}</span> // Display 'Guest' if userName is null
      );
    },
  },
  {
    field: "phone",
    headerName: "Phone",
    width: 200,
  },
  {
    field: "timestamp",
    headerName: "created at",
    width: 200,
    valueGetter: (params) => formatDate(params.value), // Use valueGetter to format createdAt field
  },
  
];
